import React, { Component } from "react";
import { ResponsiveLine } from "@nivo/line";

class ChartRange extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="" style={{ height: "300px", width: "100%" }}>
        <ResponsiveLine
          data={[
            {
              id: "Sales",
              color: "hsl(221, 70%, 50%)",
              data: this.props.rangeSale,
            },
          ]}
          margin={{ top: 5, right: 110, bottom: 50, left: 60 }}
          axisTop={null}
          axisRight={null}
          axisBottom={{
            orient: "bottom",
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: "",
            legendOffset: 36,
            legendPosition: "middle",
          }}
          axisLeft={{
            orient: "left",
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: "",
            legendOffset: -40,
            legendPosition: "middle",
          }}
          colors={["#4daf51"]}
          index="Sales"
          lineWidth={3}
          enableGridX={true}
          enableGridY={true}
          enablePoints={true}
          pointSize={10}
          pointColor={{ theme: "background" }}
          pointBorderWidth={2}
          pointBorderColor={{ from: "serieColor" }}
          pointLabel="Sale"
          pointLabelYOffset={-1}
          enableArea={true}
          areaBaselineValue={0}
          useMesh={true}
          enableSlices="x"
          enableCrosshair={false}
          legends={[
            {
              anchor: "bottom-right",
              direction: "column",
              justify: false,
              translateX: 100,
              translateY: 0,
              itemsSpacing: 0,
              itemDirection: "left-to-right",
              itemWidth: 80,
              itemHeight: 20,
              itemOpacity: 0.75,
              symbolSize: 12,
              symbolShape: "circle",
              symbolBorderColor: "rgba(0, 0, 0, .5)",
              effects: [
                {
                  on: "hover",
                  style: {
                    itemBackground: "rgba(0, 0, 0, .03)",
                    itemOpacity: 1,
                  },
                },
              ],
            },
          ]}
        />
      </div>
    );
  }
}

export default ChartRange;
